let Tabsnav = (function() {

    'use strict';

    function init(elm) {
        document.addEventListener('DOMContentLoaded', () => {
            if (typeof (Storage) !== 'undefined') {

                const navs = document.querySelectorAll(elm);

                if (!navs) {
                   return;
                }

                Array.prototype.forEach.call(navs, container => {

                    let id = container.id ? container.id : 'tabsnav';

                    // See if there is a scroll pos and restore it.
                    let lastXPos = +localStorage.getItem(id + '-x');
                    if (lastXPos) {
                        //console.log('Setting scroll position to:', lastXPos);
                        container.scrollLeft = lastXPos;
                    }
                    container.classList.add('is-ready');

                    // On navigating away, save the position.
                    const anchors = container.querySelectorAll('a');

                    const onTabClick = function() {
                        //console.log('Saving scroll position to:', container.scrollLeft);
                        localStorage.setItem(id + '-x', container.scrollLeft.toString());
                    };

                    for (let i = 0; i < anchors.length; i++) {
                        anchors[i].addEventListener('click', onTabClick);
                    }

                });
            }
        });
    }

    return {
        init: init
    };

})();

export default Tabsnav;